import { lazy, type FC, type RefObject } from 'react';
import { useFragment, graphql } from 'react-relay';

import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense.tsx';
import { type PdpSharedDesignYourOwnPillLazy_item$key } from './__generated__/PdpSharedDesignYourOwnPillLazy_item.graphql.ts';

const PdpSharedDesignYourOwnPill = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedDesignYourOwnPill" */ './PdpSharedDesignYourOwnPill.tsx'
        )
);

type Props = {
    item: PdpSharedDesignYourOwnPillLazy_item$key;
    scrollToCustomizationRef: RefObject<HTMLElement | null>;
};

const itemFragment = graphql`
    fragment PdpSharedDesignYourOwnPillLazy_item on Item {
        isDyoCustomizable
    }
`;

export const PdpSharedDesignYourOwnPillLazy: FC<Props> = ({
    item: itemRef,
    scrollToCustomizationRef,
}) => {
    const item = useFragment(itemFragment, itemRef);

    if (!item?.isDyoCustomizable) {
        return null;
    }

    return (
        <ClientSuspense fallback={null}>
            <PdpSharedDesignYourOwnPill scrollToCustomizationRef={scrollToCustomizationRef} />
        </ClientSuspense>
    );
};
